<template>
  <div>
    <template v-if="type && type === 'cards'">
      <div v-show="screenSizeId <= 3">
        <nav class="navbar navbar-light bg-light shadow-sm d-block fixed-top" style="z-index:1">
          <div class="container-fluid px-0" style="padding-top:60px">
            <div class="mr-auto">
              <a v-if="config.customLeftButton" class="mr-2" href="" v-show="config.customLeftButton.show"
                 @click.prevent="clickCustomButton(config.customLeftButton)"><i
                  :class="config.customLeftButton.icon?config.customLeftButton.icon:''"></i></a>
              <a class="mr-2" href="" v-show="config.viewBack" @click.prevent="changeView(config.viewBack)"><i
                  class="fas fa-chevron-left"></i></a>
              <a class="mr-2" href="" v-show="config.leftDrawerIcon" @click.prevent="openLeftDrawer"><i
                  :class="config.leftDrawerIcon"></i></a>
            </div>
            <div class="mx-auto">
              <h6 class="my-0" v-show="config.title">{{ config.title }}</h6>
            </div>
            <div class="ml-auto">
              <a v-if="config.customRightButton" class="ml-2" href="" v-show="config.customRightButton.show"
                 @click.prevent="clickCustomButton(config.customRightButton)"><i
                  :class="config.customRightButton.icon?config.customRightButton.icon:''"></i></a>
              <a class="ml-2" href="" v-show="config.rightDrawerIcon" @click.prevent="openRightDrawer"><i
                  :class="config.rightDrawerIcon"></i></a>
              <a class="ml-2" href="" v-show="config.viewAfter" @click.prevent="changeView(config.viewAfter)"><i
                  class="fas fa-chevron-right"></i></a>
            </div>
          </div>
        </nav>
      </div>
    </template>
    <a
        class="btn btn-sm btn-light left-nav-button"
        href=""
        v-show="config.leftDrawerIcon && !leftDrawerIsOpen"
        @click.prevent="openLeftDrawer">
      <i :class="config.leftDrawerIcon"></i>
    </a>
    <a
        class="btn btn-sm btn-light right-nav-button"
        href=""
        v-show="config.rightDrawerIcon"
        @click.prevent="openRightDrawer">
      <i :class="config.rightDrawerIcon"></i>
    </a>
  </div>
</template>

<script>
export default {
  name:     "ks-menu-view-navigation",
  props:    {
    type: {
      type:    String,
      default: null
    }
  },
  computed: {
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    leftDrawerIsOpen() {
      try {
        return app.leftDrawerStatus.isOpen
      } catch (err) {
        return true
      }
    },
    rightDrawerIsOpen() {
      try {
        return app.rightDrawerStatus.isOpen
      } catch (err) {
        return true
      }
    },
    config() {
      return this.$parent.currentView;
    }
  },
  methods:  {
    changeView(view) {
      this.$parent.setCurrentView(view);
    },
    openRightDrawer() {
      app.openRightDrawer();
    },
    openLeftDrawer() {
      app.openLeftDrawer();
    },
    clickCustomButton(config) {
      try {
        config.click(this);
      } catch (err) {
        console.log('KS-APP: ', err);
      }
    }
  },
}
</script>
<style>
.left-nav-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 3;
}

.right-nav-button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  position: fixed;
  top: 60px;
  right: 0;
  z-index: 3;
}
</style>